import Swal from "sweetalert2";
import i18n from "i18next";

// Backend-authored popup HTML (see showRegisterSuccessPopup) can call
// Swal.close() from an inline onclick to dismiss the popup, e.g.
// <button onclick="Swal.close()">No</button>
window.Swal = Swal;

export const hasMeaningfulContent = (html) => {
  if (!html) return false;
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent.trim().length > 0;
};

// Replace {{key}} tokens in backend-authored HTML. A key found in `vars` is
// substituted with that runtime value (e.g. a URL); anything else falls back
// to an i18next translation, e.g. <h2>{{register.popup.title}}</h2>
const applyTemplate = (html, vars = {}) => {
  if (!html) return html;
  return html.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (match, key) => {
    if (Object.prototype.hasOwnProperty.call(vars, key)) {
      return vars[key] ?? "";
    }
    return i18n.t(key);
  });
};

export const showRegisterSuccessPopup = async (triggerGetRegisterPopup, vars = {}) => {
  try {
    const popup = await triggerGetRegisterPopup().unwrap();
    const html = applyTemplate(popup?.result?.content, vars);
    if (hasMeaningfulContent(html)) {
      Swal.fire({
        icon: "info",
        html,
        showConfirmButton: false,
        showCloseButton: true,
        allowOutsideClick: false,
      });
    }

  } catch (err) {
    console.log("success");

    console.error("Failed to load register popup:", err);
  }
};
